<section class="example-section" [formGroup]="formulario">
  <label class="example-margin">{{identificacao}}</label>
  <mat-radio-group [required]="requerido" [formControlName]="nomeControle" (selectionChange)="onSelectionChange($event)"
    color="primary">
    <mat-radio-button class="example-margin" *ngFor="let opcao of opcoes" [value]="opcao.valor">{{opcao.descricao | transloco}}
    </mat-radio-button>
  </mat-radio-group>
</section>
<mat-hint [class]="danger? 'custom-hint-danger': ''">{{textoAjuda}}</mat-hint>